import React from 'react';
import CommonSessionForm from 'pages/admin/feature/form/CommonSessionForm';

const CommonSessionCreate = () => {
    return <CommonSessionForm />;
};

export default CommonSessionCreate;
